import React from "react";
import Flag from "assets/images/Mark Important Symbol.png";
import TeacherIcon from "assets/images/teacher_default_icon.png";
import moment from 'moment';
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

function MessageOverview({data}) {
  const { totalUnreadMessage } = useSelector((state) => state.messages);
  const navigate = useNavigate();

  const hendleOnClickMessage = (uid, parent_name) => {
    const parentName = parent_name.replace(" ", "-");
    navigate(`/messages/${uid}-${parentName}`);
  }

  return (
    <div className="max-w-screen-lg mx-auto">
      <div className="pt-[50px] px-[50px] pb-[150px] w-full">
        <h1 className="font-gluten font-bold text-4xl">
          Messages Overview <span className="text-custom-red">{totalUnreadMessage > 0 && `(${totalUnreadMessage})`}</span>
        </h1>
        <div className="grid grid-cols-2 gap-[17px] mt-[50px]">
          {data.map((item, index) => {
            return (
              <div
                key={index}
                className="p-[25px] flex items-start bg-message-bg rounded-[20px] overflow-hidden"
              >
                <div className="w-[60px] h-[60px] rounded-full border-[2px] border-custom-navy overflow-hidden mr-[25px] flex-shrink-0">
                  <img
                    src={TeacherIcon}
                    className="w-full h-full object-contain"
                    alt=""
                  />
                </div>
                <div className="flex flex-col gap-[18px] overflow-hidden">
                  <div className="flex items-center">
                    <h4 className="text-2xl text-custom-navy font-bold cursor-pointer" onClick={ () => hendleOnClickMessage(item.uid, item.parent_name) }>
                      {item.parent_name} (Parent)
                    </h4>
                    {item.is_important ? (
                      <div className="h-7 w-7 ml-2">
                        <img
                          src={Flag}
                          className="h-full w-full object-contain"
                          alt=""
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <p className="text-[22px] truncate ... w-full text-custom-secondary">
                    {item.message}
                  </p>
                  <p className="text-lg text-form-color uppercase tracking-[2.34px] opacity-[0.6]">{moment(item.tstamp_create).format('HH:ssA')}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default MessageOverview;
